import paymentService from "../services/payment.service";
import { APPROVE_PAID_UP_CAPITAL, GET_PAID_UP_CAPITAL, GET_PAYMENTS, SET_FAILED_MESSAGE, SET_SUCCESS_MESSAGE, START_LOADER, STOP_LOADER } from "./types";

export const getPaymentAction = (page, perPage) => (dispatch) => {
  if (page > 1) {
    dispatch({ type: START_LOADER });
  }
  return paymentService.getPayment(page, perPage).then((resp) => {
    dispatch({ type: GET_PAYMENTS, payload: resp.status ? resp.data : [], page: page, count: resp.status ? resp.count : 0 });
    dispatch({ type: STOP_LOADER });
  });
};


export const updatePaymentStatusAction = (id, payload, page, perPage) => (dispatch) => {
  dispatch({ type: START_LOADER });
  return paymentService.updatePaymentStatus(id, payload).then((resp) => {
    dispatch(getPaymentAction(1, perPage))
    dispatch({ type: STOP_LOADER });
    dispatch({ type: resp.status ? SET_SUCCESS_MESSAGE : SET_FAILED_MESSAGE, payload: resp.data });
    return Promise.resolve();
  });
};


export const updatePaymentApprovalStatusAction = (id, payload, page, perPage) => (dispatch) => {
  dispatch({ type: START_LOADER });
  return paymentService.updatePaymentApprovalStatus(id, payload).then((resp) => {
    dispatch({ type: STOP_LOADER });
    dispatch(getPaymentAction(1, perPage))
    dispatch({ type: resp.status ? SET_SUCCESS_MESSAGE : SET_FAILED_MESSAGE, payload: resp.data });
    return Promise.resolve();
  });
};

export const getPaidUpCapitalAction = (page, limit, companyId = "") => (dispatch) => {
  dispatch({ type: START_LOADER });
  return paymentService.getPaidUpCapital(page, limit, companyId).then((resp) => {
    dispatch({
      type: GET_PAID_UP_CAPITAL,
      payload: resp.status ? resp.data : [],
      count: resp.status ? Math.ceil(resp.total / resp.limit) : 0,
      total: resp.status ? resp.total : 0,
    });
    dispatch({ type: STOP_LOADER });
    return Promise.resolve(resp);
  });
};

export const approvePaidUpCapitalAction = (capital, filterBody = null) => (dispatch) => {
  dispatch({ type: START_LOADER });
  return paymentService.approvePaidUpCapital({ capital }).then((resp) => {
    dispatch({ type: STOP_LOADER });
    dispatch({ type: APPROVE_PAID_UP_CAPITAL, payload: resp });
    dispatch({ type: resp.status ? SET_SUCCESS_MESSAGE : SET_FAILED_MESSAGE, payload: resp.message });
    if (resp.status && filterBody) {
      dispatch(getPaidUpCapitalAction(filterBody.page, filterBody.limit, filterBody.companyId));
    }
    return Promise.resolve(resp);
  });
};
